import { Skeleton } from '@mais-retorno-front/components/skeleton';
import { Box, Container, useTheme } from '@mui/material';
import React from 'react';

export const WordOfDaySkeleton = () => {
  const theme = useTheme<any>();
  return (
    <Box py={6} bgcolor={theme.palette.backgroundColor.main}>
      <Container maxWidth={false}>
        <Skeleton width="250px" height="32px" />
        <Box mt={8}>
          <Skeleton width="200px" height="32px" />
          <Skeleton width="100%" height="20px" margin={{ top: 8 }} />
          <Skeleton width="80%" height="20px" margin={{ top: 8 }} />
        </Box>

        <Box mt={8}>
          <Skeleton width="250px" height="32px" />
          <Box mt={4}>
            <Skeleton width="150px" height="20px" />
            <Skeleton width="200px" height="20px" margin={{ top: 8 }} />
            <Skeleton width="100px" height="20px" margin={{ top: 8 }} />
            <Skeleton width="150px" height="20px" margin={{ top: 8 }} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
